// client/src/routes/portal/index.tsx — SCR-PORT-001 „Portal — Acasă" · PORTAL-002 phase 2.
//
// Phase 1's `PlaceholderScreen` is replaced in place: the route, its tab wiring and the §6.6
// order do not move, which is what D-1179 promised.
//
// No permission guard: the shell's own `beforeLoad` has already established that the visitor is
// a tenant, and `Portal.Self` is the only code a tenant holds (03 §17.1) — a second gate here
// would be the same check written twice. The scope's own three async states are
// `ContractScope`'s (§5.11).

import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { PageHeader } from '@/components/layout/PageHeader';
import { ContractScope } from '@/features/portal/ContractScope';
import { PortalHome } from '@/features/portal/PortalHome';
import { PortalSkeleton } from '@/features/portal/PortalSkeletons';

export const Route = createFileRoute('/portal/')({
  component: PortalHomeScreen,
});

function PortalHomeScreen() {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('portal.home.title')} description={t('portal.home.subtitle')} />
      {/* The wait is shaped like the arrival: the contract card, then the four status
          cards, in the boxes they land in (D-1682). The cards are not inside a card, as the
          real ones are not (D-2258). */}
      <ContractScope
        pending={
          <div className="space-y-6">
            <PortalSkeleton shape="facts" className="portal-card" />
            <PortalSkeleton shape="cards" count={4} />
          </div>
        }
      >
        {(contract) => <PortalHome contract={contract} />}
      </ContractScope>
    </>
  );
}
